import styles from './QualificationBadges.module.scss';
import { CircleCheck, CircleX, CircleQuestionMark } from 'lucide-react';
import { FormattedQualifications } from 'contexts/LiveKitContext';

export const QualificationBadges = ({
    qualifications,
    isAllNoAnswer = false,
    showTitle = true,
    embedded = false,
}: {
    qualifications: FormattedQualifications[];
    isAllNoAnswer?: boolean;
    showTitle?: boolean;
    embedded?: boolean;
}) => {
    return (
        <div className={embedded ? styles.qualificationsEmbedded : styles.qualificationsSection}>
            {showTitle && <h3>Qualifications</h3>}
            {qualifications.length ? (
                qualifications.map(({ key, label, value, isTrue, isFalse, isUnknown }) => (
                    <div
                        key={key}
                        className={`${styles.qualificationBadge} ${isTrue ? styles.qualificationBadgeTrue : isFalse ? styles.qualificationBadgeFalse : styles.qualificationBadgeUnknown}`}
                    >
                        <span>{label}</span>

                        <span className='flex items-center gap-sm' style={{ wordBreak: 'break-all' }}>
                            {isTrue && <CircleCheck color='var(--success-color)' style={{ flexShrink: 0 }} size={16} />}
                            {isFalse && <CircleX color='var(--error-color)' style={{ flexShrink: 0 }} size={16} />}
                            {isUnknown && (
                                <CircleQuestionMark color='var(--warning-color)' style={{ flexShrink: 0 }} size={16} />
                            )}
                            {value}
                        </span>
                    </div>
                ))
            ) : isAllNoAnswer ? (
                <div className='text-base'>Sorry, no qualifications found</div>
            ) : (
                <div className='text-base'>Loading qualification results...</div>
            )}
        </div>
    );
};
